import ApiServiceCustom from "../services/ApiServiceCustom";

const obterCoordenadorias = async (defaultUrl, redeEnsino, municipioId) => {
  if (!redeEnsino || !municipioId) {
    return [];
  }
  return await ApiServiceCustom.get({
    defaultUrl: defaultUrl,
    resource: "coordenadoria",
    slug: `/listagem/${redeEnsino}/${municipioId}`,
  })
    .then(({ data }) => {
      return data.dados.map((data) => {
        return {
          value: data.id,
          label: data.nome,
        };
      });
    })
    .catch((e) => {
      return [];
    });
};

const coordenadoriasPerfilDeDados = async (redeEnsino, municipioId) => {
  return await obterCoordenadorias(
    process.env.VUE_APP_ADMIN_API,
    redeEnsino,
    municipioId
  );
};

const coordenadoriasPorRede = async (redeEnsino, municipioId) => {
  return await obterCoordenadorias(
    process.env.VUE_APP_ORGANIZACAO_GEOGRAFICA_API,
    redeEnsino,
    municipioId
  );
};

export { coordenadoriasPerfilDeDados, coordenadoriasPorRede };
